import { ReactText } from 'react';
import { getLoggedUser } from 'utils/storage';

class Form {
  id?: ReactText = '';
  name?: string = '';
  completed?: boolean;
  createdBy?: number = 0;
  updatedBy?: number = 0;
  status?: string = 'DRAFT';
  clientId?: ReactText = '';
  // completed?: boolean;
  constructor() {
    this.createdBy = getLoggedUser().id;
    this.updatedBy = getLoggedUser().id;
    this.clientId = getLoggedUser().client;
    this.completed = false;
  }
}

export default Form;
